import React from "react";
import { Plus } from "react-bootstrap-icons";

function AddItemButton({ onClick }) {
    return (
        <div
            className="text-center footer-button w-100 d-flex align-items-center justify-content-center"
            style={{
                borderRadius: '0.375rem',
                cursor: "pointer",
                flexShrink: 0,
                backgroundColor: "rgb(240 242 245)",
            }}
            onClick={onClick}
        >
            <Plus size={40} className="text-primary" />
        </div>
    );
}

export default AddItemButton;